import { render } from "./link-catalog.vue?vue&type=template&id=99a8f45a"
import script from "./link-catalog.vue?vue&type=script&setup=true&lang=js"
export * from "./link-catalog.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/link-catalog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "99a8f45a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('99a8f45a', __exports__)) {
    console.log('reload')
    api.reload('99a8f45a', __exports__)
  }
  
  module.hot.accept("./link-catalog.vue?vue&type=template&id=99a8f45a", () => {
    console.log('re-render')
    api.rerender('99a8f45a', render)
  })

}


export default __exports__